import { cn } from "@/lib/utils";
/**
 * La pillola di stato. Il colore dice lo stato, ma non da solo: c'è sempre
 * il pallino + l'etichetta. Un colore = un significato, in tutta l'app.
 *
 * Stati del preventivo (schema): bozza · da_rivedere · approvato · inviato.
 * Stati generici: neutro · ok · attenzione · errore · info.
 */
export const STATI = {
  bozza: { label: "Bozza", pill: "bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
  da_rivedere: { label: "Da rivedere", pill: "bg-warning-subtle text-warning-foreground", dot: "bg-warning" },
  approvato: { label: "Approvato", pill: "bg-success-subtle text-success-foreground", dot: "bg-success" },
  inviato: { label: "Inviato", pill: "bg-brand-subtle text-brand-subtle-foreground", dot: "bg-primary" },
  neutro: { label: "", pill: "bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
  ok: { label: "", pill: "bg-success-subtle text-success-foreground", dot: "bg-success" },
  attenzione: { label: "", pill: "bg-warning-subtle text-warning-foreground", dot: "bg-warning" },
  errore: { label: "", pill: "bg-danger-subtle text-danger-foreground", dot: "bg-danger" },
  info: { label: "", pill: "bg-brand-subtle text-brand-subtle-foreground", dot: "bg-primary" },
};
export const statoLabel = (stato) => STATI[stato]?.label || stato;
export default function StatusPill({ stato = "neutro", children, className, dot = true, ...props }) {
  const s = STATI[stato] || STATI.neutro;
  return (
    <span
      className={cn(
        "inline-flex h-6 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-medium",
        s.pill,
        className,
      )}
      {...props}
    >
      {dot ? <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} aria-hidden /> : null}
      {children ?? s.label}
    </span>
  );
}
